import { ContentStatus } from 'models/Content';
import React, { useRef } from 'react';
import { Globe, FileMinus, Lock, Minus } from 'react-feather';
import type { Icon } from 'react-feather';
import { UncontrolledTooltip } from 'reactstrap';

type IProps = {
  contentStatus: ContentStatus | '';
};

const STATUS_ICON: Partial<Record<ContentStatus, Icon>> = {
  [ContentStatus.Published]: Globe,
  [ContentStatus.Inactive]: Lock,
  [ContentStatus.Draft]: FileMinus,
};

export const ContentStatusIcon = ({ contentStatus }: IProps) => {
  const targetRef = useRef<HTMLSpanElement>(null);
  const StatusIcon = contentStatus ? STATUS_ICON[contentStatus] : undefined;

  if (!StatusIcon) {
    return (
      <Minus
        size={20}
        className="gray-500"
      />
    );
  }

  return (
    <>
      <span
        ref={targetRef}
        className="d-inline-flex"
      >
        <StatusIcon
          size={20}
          className="gray-500"
        />
      </span>
      <UncontrolledTooltip
        container="body"
        placement="bottom"
        target={targetRef}
      >
        {contentStatus}
      </UncontrolledTooltip>
    </>
  );
};
